import React, { useEffect, useRef, useState } from "react";
import { Avatar, Button, Col, Input, List, Row, Space, Tooltip, Typography } from "antd";
import { LikeOutlined, LikeFilled, UserOutlined, SendOutlined, LeftCircleFilled, RightCircleFilled } from "@ant-design/icons";
import superuserService from "@/services/superadminService";
import { ArrowDown, ArrowUp, MoveLeft } from "lucide-react";
import dayjs from "dayjs";
const { TextArea } = Input;
const { Paragraph, Text } = Typography;

const ChartComments = React.forwardRef((props, ref) => {

  const getusername = localStorage.getItem("username")
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const scrollRef = useRef(null);

  const scrollContainer = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = 300; // pixels to scroll
    if (direction === 'left') {
      scrollRef.current.scrollLeft -= scrollAmount;
    } else {
      scrollRef.current.scrollLeft += scrollAmount;
    }
  };

  const arrowStyle = (position) => ({
    position: 'absolute',
    top: '35%',
    [position]: '10px',
    transform: 'translateY(-50%)',
    backgroundColor: '#10b981',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    zIndex: 5,
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });
  useEffect(() => {
    if (props?.getchartid?.commentlist?.length) {
      setComments(
        props.chartcomments
          .filter(comment => props?.getchartid?.commentlist.includes(comment.id))  // ✅ only selected comments
          .map(comment => ({
            id: comment.id,
            author: getusername,
            content: comment.comments,
            date: new Date(comment.createdAt).toLocaleString(),
          }))
      );
    }
    else if (props?.chartcomments?.length) {

      setComments(
        props.chartcomments.map((comment) => ({
          id: comment.id,
          author: getusername,
          content: comment.comments,
          date: new Date(comment.createdAt).toLocaleString(), // Formats date to readable string

        }))
      );
    }
  }, [props.chartcomments]);

  const addComment = async () => {
    if (!newComment.trim()) return;
    setComments([
      ...comments,
      {
        author: getusername,
        content: newComment,
        date: new Date().toISOString(),
      },
    ]);
    const payload = {
      chart_id: props?.getchartid?.chart_id,
      comments: newComment,
      date: new Date().toISOString()
    };

    await superuserService.addUserComments(payload);
    setNewComment("");
  };

  return (
    <div style={{
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
      width: "100%"
    }}>

      <Typography.Text className="ms-2" strong> Comments ({comments?.length || 0})</Typography.Text>


      <Row gutter={12} style={{ marginTop: '10px', position: 'relative' }} ref={ref}>
        {comments?.length ? comments.map((comment) => (
          <Col

            key={comment.id}
            xs={24}
            sm={12}
            md={8}
            lg={6}
            xl={6}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative'
            }}
          >
            {/* Comment Card */}
            <div
              style={{
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '16px',
                width: '100%',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
                marginBottom: '20px',  // More space for timeline
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 15px -3px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
              }}
            >
              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <Avatar style={{ backgroundColor: "#03B08D", flexShrink: 0 }}>
                  <UserOutlined className="text-white" />
                </Avatar>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text strong style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                      <strong className="ms-2">{comment.author}</strong>
                    </Text>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div style={{ minHeight: '60px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <Tooltip title={comment.content.length > 120 ? comment.content : null} placement="bottom">
                  <Text style={{
                    fontSize: '13px',
                    lineHeight: '1.5',
                    color: '#374151',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {comment.content}
                  </Text>
                </Tooltip>
              </div>
            </div>

            {/* Timeline Footer */}

            <div style={{
              width: '100%',
              textAlign: 'center',
              position: 'relative',
              marginBottom: '20px', // enough space for the arrow to appear
            }}>
              {/* Timeline line */}
              <div
                style={{
                  height: '2px',
                  backgroundColor: '#10b981',
                  position: 'absolute',
                  top: '50%',
                  left: 0,
                  right: 0,
                  zIndex: 0
                }}
              />

              {/* Date Badge */}
              <span
                className="bg-success-subtle rounded-3"
                style={{
                  position: 'relative',
                  backgroundColor: '#fff',
                  padding: '2px 5px',
                  fontSize: '12px',
                  color: '#0A9A7C',
                  zIndex: 1,
                }}
              >
                {dayjs(comment?.date).format('YYYY/MM/DD, h:mm:ss A')}
              </span>

              <ArrowUp
                size={16}
                color="#10b981"
                style={{
                  position: 'absolute',
                  bottom: 'calc(100% - 0px)',
                  left: '50%',
                  transform: 'translateX(-50%)'
                }}
              />
            </div>

          </Col>
        )) : <Typography.Text className="mx-auto fs-12" >No Comments</Typography.Text >}
      </Row>


      {/* Comment Input */}
      <div style={{
        backgroundColor: '#f9fafb',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        padding: '20px'
      }}>
        <div style={{
          display: 'flex',
          gap: '12px',
          alignItems: 'flex-end'
        }}>
          <div style={{ flex: 1 }}>
            <TextArea
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              placeholder="Write a comment..."
              autoSize={{ minRows: 3, maxRows: 5 }}
              style={{
                borderRadius: '8px',
                border: '1px solid #d1d5db',
                fontSize: '14px',
                resize: 'none'
              }}
              onPressEnter={(e) => {
                if (e.shiftKey) return;
                e.preventDefault();
                addComment();
              }}
            />
          </div>
          <Button
            type="primary"
            icon={<SendOutlined />}
            onClick={addComment}
            disabled={!newComment.trim()}
            style={{
              backgroundColor: '#10b981',
              borderColor: '#10b981',
              borderRadius: '8px',
              height: '44px',
              width: '100px',
              fontWeight: '500'
            }}
          >
            Submit
          </Button>
        </div>
      </div>


    </div>
  );
});

export default ChartComments;
